// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../provider/Context.bs.js";
import * as User_Api from "../user/User_Api.bs.js";
import * as Util_I18n from "../util/Util_I18n.bs.js";
import * as Zone_Type from "../zone/Zone_Type.bs.js";
import * as User_Context from "../user/User_Context.bs.js";
import * as UsePagination from "./UsePagination.bs.js";
import * as User_Provider from "../user/User_Provider.bs.js";

function make2(zone) {
  var match = Context.Config.getState(undefined);
  var loadNextPage = match.api.loadNextPage;
  var match$1 = Context.I18n.getState(undefined);
  var locale = match$1.locale;
  var formaters = match$1.formaters;
  var match$2 = match$1.labels.teaser;
  var minutesLabel = match$2.durationUnit;
  var ssoEnv = User_Context.getEnv(undefined);
  var nextBroadcastDate = formaters.nextBroadcastDate;
  var betweenDates = formaters.betweenDates;
  var dateFormater = formaters.availabilityDate;
  var token = Curry._1(User_Provider.Hook.useToken, undefined);
  var tokenRef = React.useRef(token);
  tokenRef.current = React.useMemo((function () {
          return token;
        }), [token]);
  var loadNextPageRef = React.useRef(function (param, param$1) {
        return Promise.resolve(/* NotReady */0);
      });
  loadNextPageRef.current = (function (zone, nextPage) {
      switch (nextPage.TAG | 0) {
        case /* Club */1 :
            var page = nextPage._1;
            if (page === undefined) {
              return Promise.resolve(/* NoMoreData */1);
            }
            var kind = nextPage._0;
            var token = tokenRef.current;
            if (token !== undefined) {
              return User_Api.NextPage.get(token, Util_I18n.localeToLanguage(locale), kind, page)(ssoEnv).then(function (res) {
                          if (res.TAG !== /* Ok */0) {
                            if (res._0 === 0) {
                              return /* NotReady */0;
                            } else {
                              return /* NoMoreData */1;
                            }
                          }
                          var match = res._0;
                          var zone$1 = Zone_Type.makeFromClub(minutesLabel, zone, kind, match[1], match[0]);
                          return /* Ready */{
                                  _0: {
                                    nextPage: zone$1.nextPage,
                                    data: zone$1.data
                                  }
                                };
                        });
            } else {
              return Promise.resolve(/* NotReady */0);
            }
        case /* Emac */0 :
        case /* EmacV4 */2 :
            break;
        
      }
      return Curry._5(loadNextPage, dateFormater, betweenDates, nextBroadcastDate, zone, nextPage._0).then(function (zone) {
                  if (zone == null) {
                    return /* NoMoreData */1;
                  } else {
                    return /* Ready */{
                            _0: {
                              nextPage: zone.nextPage,
                              data: zone.data
                            }
                          };
                  }
                });
    });
  return React.useRef(UsePagination.asyncMode(zone.nextPage, Curry._1(loadNextPageRef.current, zone))).current;
}

export {
  make2 ,
}
/* react Not a pure module */
